export const shortHandInfo = (type: 'email' | 'address', val: string) => {
  switch (type) {
    case 'email':
      return `${val.substring(0, Math.floor(val.length / 2))}...`

    case 'address':
      return `${val.substring(0, 4)}...${val.substring(val.length - 4)}`
  }
}
